// ═══════════════════════════════════════
// ATTACHMENTS — Fichiers annexes (score PDF, audio)
// ═══════════════════════════════════════

import { authHeaders } from './common/auth.js';
import { sessionToken, currentId } from './state.js';
import { t } from './i18n.js';

let currentScoreExt = null;
let currentAudioExt = null;

export function toggleAttachPanel() {
    document.getElementById('attach-panel').classList.toggle('open');
}

const MAX_SCORE_MB = 10;
const MAX_AUDIO_MB = 20;

export function onAttachChange() {
    const scoreFile = document.getElementById('file-score').files[0];
    const audioFile = document.getElementById('file-audio').files[0];

    if (scoreFile && scoreFile.size > MAX_SCORE_MB * 1024 * 1024) {
        alert(t('attach.error_score_size', { max: MAX_SCORE_MB }));
        document.getElementById('file-score').value = '';
        return;
    }
    if (audioFile && audioFile.size > MAX_AUDIO_MB * 1024 * 1024) {
        alert(t('attach.error_audio_size', { max: MAX_AUDIO_MB }));
        document.getElementById('file-audio').value = '';
        return;
    }

    const hasScore = !!document.getElementById('file-score').files.length;
    const hasAudio = !!document.getElementById('file-audio').files.length;
    document.getElementById('btn-attach').classList.toggle('has-files', hasScore || hasAudio);
}

export async function uploadAttachments(id) {
    const fileScore = document.getElementById('file-score').files[0];
    const fileAudio = document.getElementById('file-audio').files[0];
    if (!fileScore && !fileAudio) return;

    const fd = new FormData();
    if (fileScore) fd.append('score', fileScore, fileScore.name);
    if (fileAudio) fd.append('audio', fileAudio, fileAudio.name);

    await fetch(`/api/partitions.php?id=${id}`, {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + sessionToken },
        body: fd
    });

    document.getElementById('file-score').value = '';
    document.getElementById('file-audio').value = '';
    document.getElementById('btn-attach').classList.remove('has-files');
    document.getElementById('attach-panel').classList.remove('open');
}

export async function refreshAttachButtons(id) {
    currentScoreExt = null;
    currentAudioExt = null;
    document.getElementById('score-btn').style.display     = 'none';
    document.getElementById('audio-ext-btn').style.display = 'none';
    if (!id) return;
    try {
        const res  = await fetch(`/api/partitions.php?id=${id}&meta=1`, { headers: authHeaders() });
        const meta = await res.json();
        if (meta.score) { currentScoreExt = meta.score; document.getElementById('score-btn').style.display = ''; }
        if (meta.audio) { currentAudioExt = meta.audio; document.getElementById('audio-ext-btn').style.display = ''; }
    } catch(e) {}
}

export function openScoreFile() {
    if (!currentId || !currentScoreExt) return;
    window.open(`/files/${currentId}_score.${currentScoreExt}`, '_blank');
}

export function openAudioFile() {
    if (!currentId || !currentAudioExt) return;
    window.open(`/files/${currentId}_audio.${currentAudioExt}`, '_blank');
}